var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16634 4.5V11.1667H2.83301V4.5H8.16634ZM7.16634 0.5H3.83301L3.16634 1.16667H0.833008V2.5H10.1663V1.16667H7.83301L7.16634 0.5ZM9.49967 3.16667H1.49967V11.1667C1.49967 11.9 2.09967 12.5 2.83301 12.5H8.16634C8.89967 12.5 9.49967 11.9 9.49967 11.1667V3.16667Z",
    fill: "#E93030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDelete);
export default __webpack_public_path__ + "static/media/redDelete.fd5c22331c93fbb050aa1d73f934e8d3.svg";
export { ForwardRef as ReactComponent };